export const normalizeDashboardLocale = value =>
  String(value || '')
    .toLowerCase()
    .split(/[-_]/)[0] === 'en'
    ? 'en'
    : 'pt_BR';
